import {TASKMANAGE} from 'Constants/ActionTypes';
const {GET_TASK_LIST_ALL,POST_TASK_MONITORING,SET_MONITORING_ID}=TASKMANAGE;
const initialState = {
  tasksDataList:[] ,
  taskMonitoringList:[],
  taskMonitoringId:''
}

const monitoring = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_TASK_LIST_ALL}_SUCCESS`:
      return {
        ...state,
        tasksDataList: action.payload.data || [],
      };
    case `${POST_TASK_MONITORING}_SUCCESS`:
      return {
        ...state,
        taskMonitoringList: action.payload.data || [], 
      };
    case `${SET_MONITORING_ID}`:
      return{
        ...state,
        taskMonitoringId:action.payload.id || ''
      };
    default:
      return state;
  }
}
export default monitoring;